import React from "react";
import { Box } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import NewsCategoryListItemViewTablet from "./news-category-list-item-view-tablet";

const useStyles = makeStyles({
  categoryWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    borderBottom: "1px solid #ddd",
    marginBottom: "20px",
  },
});

const NewsCategoryListViewPhone = ({
  locale,
  data,
  location,
  currentNewsCategory,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.categoryWrapper}>
      {data?.map((n, i) =>
        n.name != "news-category-recycled" ? (
          <NewsCategoryListItemViewTablet
            locale={locale}
            key={i}
            data={n}
            location={location}
            currentNewsCategory={currentNewsCategory}
          />
        ) : (
          ""
        )
      )}
    </Box>
  );
};

export default NewsCategoryListViewPhone;
